"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var CustomFlagWrapper = styled_components_1.default.div.attrs(function () { return ({ 'data-testid': 'customFlag' }); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0.3rem 0.6rem;\n  margin: 0 0.18rem 0.18rem 0;\n  background: ", ";\n  color: ", ";\n"], ["\n  padding: 0.3rem 0.6rem;\n  margin: 0 0.18rem 0.18rem 0;\n  background: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.component.product.flag.background;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.product.flag.color;
});
var CustomFlag = function (_a) {
    var text = _a.text;
    return (react_1.default.createElement(CustomFlagWrapper, { "data-testid": "customFlag" }, text));
};
exports.default = CustomFlag;
var templateObject_1;
//# sourceMappingURL=CustomFlag.js.map